export default "__VITE_ASSET__CqqIcbL4__"